<!--
 * @Author: yzr
 * @Date: 2020-11-26 16:28:59
 * @LastEditors: yzr
 * @LastEditTime: 2020-12-04 16:16:56
-->
<template>
  <div @click="openModal">
    <!-- 弹框 -->
    <el-input
      :placeholder="placeholder"
      :value="name || value"
      :disabled='!!edit'
      @blur="blurInput"
      readonly
    ></el-input>
    <SelectConfig ref="selectConfig" @onGetSelect="onGetSelect" />
  </div>
</template>

<script>
import SelectConfig from '../../../../../../../components/select_org_cus_ter/select_config.vue';

const cusColumn = [
  { field: 'customerCode', title: '客户编码' },
  { field: 'customerName', title: '客户名称' },
];
export default {
  name: 'NoticeManageTableForm',
  components: {
    SelectConfig,
  },
  props: {
    placeholder: String,
    value: String,
    functionCode: String,
    edit: String,
    name: String,
    parentCode: String,
  },
  data() {
    return {
      modalConfig: {}, // 弹框信息
      firstColumn: cusColumn,
      // name: '',
    };
  },
  methods: {
    blurInput() {
      this.$emit('blur');
    },
    onGetSelect(val) {
      this.$emit('setCusName', val[0]);
      // this.$nextTick(() => {
      //   this.name = val[0].customerName;
      //   console.log(this.name);
      // });
    },
    // 判断去重
    getReset(list1, list2, key) {
      const list = list2;
      list1.forEach((v1) => {
        let notRepeat = true;
        const rowData = v1;
        for (const v2 in list2) {
          if (v1[key] === list2[v2][key]) {
            notRepeat = true;
            return false;
          }
        }
        if (notRepeat) {
          list.push(rowData);
        }
        return rowData;
      });
      return list;
    },
    // 打开弹窗
    openModal() {
      const params = {
        functionCode: this.functionCode,
        tableUrl: '/mdm/mdmCustomerMsgController/page',
        data: [],
        parentCode: this.parentCode,
        selectionList: [],
        idKey: 'customerCode',
      };
      if (!this.edit) this.$refs.selectConfig.openSelectModal(params);
    },
  },
};
</script>

<style lang="less" scoped>
</style>
